<template>
  <div class="layout-box">
    <div class="head-wh">
      <div class="title-center"><span>{{ headtitle }}</span></div>
     <AccountInfo :keepalives="kls" ></AccountInfo><!-- :permissions="permissions"-->
    </div>
    <div class="secondary-content">
      <div class="pdwk-l">
        <div class="pdwk-l-t">
          <div style="height: 100%; width: 420px; display: inline-block; padding: 15px 10px 5px 15px; box-sizing: border-box">
            <Echartring :configs="myconfigring4" ref="myconfigring4"></Echartring>
          </div>
          <div style="display: inline-block; width: 420px; height: 100%; vertical-align: bottom">
            <h3 style="text-align: center; color: #F4F7FF ; font-size: 19px; padding-top: 10px">本月设备维修订单</h3>
            <div class="clinch-deal-list">
              <p><span>#</span><span>设备</span><span>维修原因</span><span>状态</span></p>
              <ul>
                <vue-seamless-scroll :data="repairList" :class-option="classOption" class="seamless-warp">
                  <li v-for="(item,index) in repairList" :key="index"><span><em>{{ index+1 }}</em></span><span :title="item.equipNode">#{{ item.equipNode }}机</span><span :title="item.repairType">{{ item.repairType }}</span><span><el-button :type="item.status=='维修中'?(item.status=='维修完成'?'info':'success'):'primary'" size="mini" plain>{{ item.status }}</el-button></span></li>
                </vue-seamless-scroll>
              </ul>
            </div>
          </div>
        </div>
        <div class="pdwk-l-b">
          <div class="summary"><p>设备汇总值，汇总设备<a>{{ workAll.total*2 }}</a>台，停机<a>{{down}}</a>台，正常运行<a>{{workAll.total*2-down}}</a>台</p></div>
          <div class="workshop">
            <div class="workshop-one">
              <ul>
                <li v-for="(item,index) in equipList.slice(0,10)" :class="[item.onLine==0?'error-st':'',(index+1)%4==3||(index+1)%4==0?'orientation-lt':'']" :key="item.id" @click="clickgetdtail(item.equipNode,index+1)" :style="timer==index+1?'background: rgba(222,217,20,0.75);':''">
                  <div class="point-st">
                    <em class="halo"></em>
                    <i class="line" v-if="item.onLine==0"></i>
                    <div class="hint" v-if="item.onLine==0">
                      <p>{{ index+1 }}号机</p>
                      <p>已停机</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="workshop-two">
              <ul>
                <li v-for="(item,index) in equipList.slice(10,22)" :class="item.onLine==0?'error-st':''" :key="item.id" @click="clickgetdtail(item.equipNode,index+11)" :style="timer==index+11?'background: rgba(222,217,20,0.75);':''">
                  <div class="point-st">
                    <em class="halo"></em>
                    <i class="line" v-if="item.onLine==0"></i>
                    <div class="hint" v-if="item.onLine==0">
                      <p>{{ index+11 }}号机</p>
                      <p>已停机</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="workshop-three">
              <ul>
                <li v-for="(item,index) in equipList.slice(13,24)" :class="[item.onLine==0?'error-st':'',(index+1)%4==3||(index+1)%4==0?'orientation-lt':'']" :key="item.id" @click="clickgetdtail(item.equipNode,index+23)" :style="timer==index+23?'background: rgba(222,217,20,0.75);':''">
                  <div class="point-st">
                    <em class="halo"></em>
                    <i class="line" v-if="item.onLine==0"></i>
                    <div class="hint" v-if="item.onLine==0">
                      <p>{{ index+23 }}号机</p>
                      <p>已停机</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="workshop-four">
              <ul>
                <li v-for="(item,index) in equipList.slice(8,22)" :class="item.onLine==0?'error-st':''" :key="item.id" @click="clickgetdtail(item.equipNode,index+33,1)" :style="timer==index+33?'background: rgba(222,217,20,0.75);':''">
                  <div class="point-st">
                    <em class="halo"></em>
                    <i class="line" v-if="item.onLine==0"></i>
                    <div class="hint" v-if="item.onLine==0">
                      <p>{{ index+33 }}号机</p>
                      <p>已停机</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="oee-s">
            <div>
              <p><countTo :startVal='0' :endVal='workAll.carbonEmissions' :decimals="1" :duration='8000'></countTo><em>{{workAll.dw}}</em></p>
              <a>碳排量</a>
            </div>
            <div>
              <p><countTo :startVal='0' :endVal='workAll.operateRate' :decimals="1" :duration='8000'></countTo><em>%</em></p>
              <a>当日开机率</a>
            </div>
            <div>
              <p><countTo :startVal='0' :endVal='workAll.carbonEmissionsRate' :decimals="1" :duration='8000'></countTo><em>%</em></p>
              <a>碳排量占比</a>
            </div>
          </div>
        </div>
      </div>
      <div class="pdwk-r">
        <div class="device-info" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.3)">
          <div class="device-info-title">#{{ timer }}机运行情况<i class="run-st" :class="workDetail.equipInfo.isruning>0?'':'run-st-error'"></i></div>
          <div class="device-infos device-info-one">
            <div class="point-st" style="top: 270px;left: 736px;">
              <em class="halo"></em>
              <i class="line" style="transform: rotate(-65deg); height: 160px"></i>
              <div class="hint" style="top: 69px; left: 160px">
                <p>经纱直径：150mm</p>
                <p>经丝数：896根</p>
              </div>
            </div>
            <div class="point-st" style="top: 270px;left: 636px;">
              <em class="halo"></em>
              <i class="line" style="transform: rotate(-35deg); height: 85px"></i>
              <div class="hint" style="top: 69px; left: 50px">
                <p>纬纱直径：120mm</p>
                <p>纬丝密度：67根</p>
              </div>
            </div>
            <div class="point-st" style="top: 260px;left: 696px;">
              <em class="halo"></em>
              <i class="line" style="transform: rotate(-145deg); height: 185px"></i>
              <div class="hint" style="top: -199px; left: 130px">
                <p>织物折径：1800-2200mm</p>
                <p>梭子数：8只</p>
              </div>
            </div>
            <div class="point-st" style="top: 95px;left: 626px;">
              <em class="halo"></em>
              <i class="line" style="transform: rotate(70deg); height: 135px"></i>
              <div class="hint" style="top: 35px; left: -190px">
                <p>主机转速：75r/min</p>
                <p>卷重：630.00g</p>
              </div>
            </div>
            <div class="point-st" style="top: 276px;left: 265px; background: none;"><div class="hint" style="top: -265px; "><p>主电机功率：7.5KW</p></div></div>
            <div class="point-st" style="top: 316px;left: 265px; background: none;"><div class="hint" style="top: -265px; "><p>当日耗电：{{ workDetail.equipInfo.waterlevel }}KWh</p></div></div>
          </div>
        </div>
        <div class="device-info-st" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.3)">
          <div style="width: 175px" :class="workDetail.equipInfo.isruning>0?'':'breathing'">
            <h2 style="width: 100%;text-align: center">{{workDetail.equipInfo.isruning>0?'正常运行':'停机'}}</h2>
            <p v-if="workDetail.equipInfo.isruning==0"><span style="font-size: 24px">{{ workDetail.equipInfo.outtime }}分钟</span></p>
          </div>
          <div style="width: 265px">
            <h3 style="text-align: center;padding-top: 4px">当前订单</h3>
            <p style="margin-top: 3px"><span style="width: 100px; display: inline-block; text-align: right">开始时间：</span>{{ workDetail.equipInfo.date | parseTimes}}</p>
            <p style="margin-top: 2px"><span style="width: 100px; display: inline-block; text-align: right">颜色：</span>{{ workDetail.equipInfo.groundcolor }}</p>
          </div>
          <div style="width: 525px">
            <p style="padding-top: 21px"><span style="width: 90px; display: inline-block; text-align: right; line-height: 21px">总进度：</span><em class="skill-line"><i :style="{width:calculate(workDetail.equipInfo)+'%'}">{{ workDetail.equipInfo| percentage}}% </i></em> {{workDetail.equipInfo.plantime||0}}/<span :style="workDetail.equipInfo.runtime<0?'color:red':''">{{(workDetail.equipInfo.runtime<0?'超'+workDetail.equipInfo.runtime*-1:workDetail.equipInfo.runtime)||0}}</span></p>
            <p style="margin-top: 5px"><span style="width: 90px; display: inline-block; text-align: right">订字：</span>{{ workDetail.equipInfo.contractnumber }}</p>
          </div>
        </div>
        <div class="device-info-oee clear">
          <span v-for="(item,index) in workDetail.equipElectricityList" :key="index">{{item.hour}}<em :class="item.onLine>0?'':'error'"><i class="iconfont" :class="item.onLine>0?'icon-duihao':'icon-cuo'"></i></em></span>
          <span style="width: 76px;line-height: 120%"><a style="font-size: 12px;">综合效率</a><br><b>{{ workDetail.efficiency }}%</b></span>
        </div>
        <div class="device-info-temperature" id="echart_temperatures"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountInfo from '../layout/account-info';
import Echartring from "../../components/echart-ring"
import countTo from 'vue-count-to'
import {debounce} from '../../bll/utils'
import pinyin from 'js-pinyin'
pinyin.setOptions({checkPolyphone:false,chartCase:0})
export default {
  name: 'Pdworkshop',
  components:{
    AccountInfo,
    Echartring,
    countTo
  },
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  filters: {
    maintenances(status){
      let name=''
      switch(status*1) {
        case 0:
          name='未派单'
          break;
        case 1:
          name='已派单'
          break;
        case 2:
          name='正在处理'
          break;
        case 3:
          name='已结单'
          break;
        default:
          name='未接收'
      }
      return name
    },
    parseTimes(t){
      return t?t.replace("T"," "):''
    },
    percentage(wd){
      let pd=0
      if(wd.plantime&&wd.plantime*1!=0){
        pd=Math.round((wd.plantime-wd.runtime)*100/wd.plantime)
      }
      // this.widths=pd>100?100:pd
      return pd>100?100:pd
    },
    transcoding(name){
      return pinyin.getCamelChars(name)
    }
  },
  data () {
    return {
      headtitle:'塑编数智车间',
      kls:false,
      loading:true,
      permissions:[1],
      repairList:[],
      myconfigring4:{
        id:'num4',
        text:'本月车间分项用能',
        seriesleft:'23%',
        seriesdata:[],
        name:'本月车间分项用能'
      },
      deviceid:'',
      timer:1,
      showline:true,
      ty:0,
      getdatasid:'',
      workAll: {
        equipOee:0,
      },
      equipList:[],
      workDetail:{
        equipElectricityList:[{
          hour:'',
          onLine:''
        },{
          hour:'',
          onLine:''
        }],
        equipInfo:{
          contractnumber:'',
          date:'',
          equipNode:'',
          groundcolor:'',
          id:'',
          outtime:'',
          createtime:'',
          plantime:'',
          waterlevel:1,
          machinename:''
        }
      },
      equipInfoTwo:{},
      $_resizeHandler:null,
      $_timergetdata:null,
      widths:'',
      down:0 //停机台数
    }
  },
  computed:{
    classOption(){
      return{
        step:0.2,// 数值越大速度滚动越快
        limitMoveNum:2,// 开始无缝滚动的数据量 this.dataList.length
        hoverStop:true,// 是否开启鼠标悬停stop
        direction:1,// 0向下 1向上 2向左 3向右
        openWatch:true,// 开启数据实时监控刷新dom
        singleHeight:0,// 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth:0,// 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime:1000,// 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  created () {
    localStorage.setItem('gotourl', window.location.hash)
  },
  mounted(){
    const $this=this
    setTimeout(function () {
      $this.getdata()
    },500)
    this.$_resizeHandler = debounce(() => {
      this.getworkdetail()
    }, 1000)
    $this.dataRefresh.$ons('Refresh',()=>{
      $this.workAll={
        equipOee:0,
      }
      $this.getdata()
    })
  },
  methods:{
    getdata(){
      const url = '/api-portal/PlasticKnitting/companyList';
      const $this=this
      this.$api.get(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          // $this.workAll=datas.data
          // $this.equipList=datas.data.equipList
          $this.myconfigring4.seriesdata=(datas.data.company).map(val=>{
            return {name:val.name,value:val.value}
          })
          $this.$refs.myconfigring4.echartring()
        }
      })
      const url2 = '/api-portal/PlasticKnitting/equipList';
      this.$api.get(url2, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.workAll=datas.data
          $this.equipList=datas.data.equipList
          $this.equipList.map((item,index)=>{
            const isno=item.onLine||''
            if(isno==0){
              switch (true) {
                case index<8:
                  this.down+=1
                  break;
                case index>=8&&index<13:
                  this.down+=2
                  break;
                case index>12:
                  this.down+=3
                  break;
              }
            }
          });
          $this.getdatasid=datas.data.equipList[0].equipNode
          $this.getworkdetail()
        }
      })
      const url3 = '/api-portal/PlasticKnitting/equipRepairList';
      this.$api.get(url3, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.repairList=datas.data.equipRepairList
        }
      })
      $this.$_timergetdata=setInterval(function (){
        if($this.timer>=$this.equipList.length){
          $this.timer = 0
        }
        $this.timer+=1
        $this.getdatasid=$this.equipList[$this.timer-1].equipNode
        $this.ty=$this.timer>=45?1:0
        $this.$_resizeHandler()
      },90000)
    },
    calculate(dw){
      return this.$options.filters['percentage'](dw)
    },
    clickgetdtail(id,num,ty){
      if(id!=this.getdatasid){
        this.getdatasid=id
        this.timer=num
        this.ty=ty?ty:0
        this.$_resizeHandler()
      }
    },
    getworkdetail(){
      const $this=this
      const url1 = '/api-portal/PlasticKnitting/equipElectricityList';
      this.loading=true
      this.$api.get(url1, {equipNode: $this.getdatasid}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.workDetail=datas.data
          $this.workDetail.efficiency=$this.workDetail.efficiency.toFixed(2)
          const dateList =datas.data.dateList||[]
          const flatList =datas.data.flatList||[]
          const peakList =datas.data.peakList||[]
          const tipList =datas.data.tipList||[]
          const valleyList =datas.data.valleyList||[]
          setTimeout(function () {
            $this.drawlinediagram(dateList,flatList,peakList,tipList,valleyList)
          },500)
          if(datas.data.equipInfoTwo){
            $this.equipInfoTwo = datas.data.equipInfoTwo
          }
        }
        this.loading=false
      })
    },
    drawlinediagram(datas,datas1,datas2,datas3,datas4){
      const myEchartst = this.$echarts.init(document.getElementById('echart_temperatures'))
      let option = {
        tooltip: {
          trigger: 'axis',
          formatter:function (params) {
            let str = '';
            let num=0;
            params.forEach((item) => {
              num=num+item.data
            })
            params.forEach((item, idx) => {
              str += idx != 0? '': item.axisValue+'<br/>'
              str += idx != 0? '' : '电量汇总：'+num.toFixed(2)+'kwh<br/>'
              str += `${item.marker}${item.seriesName}: ${item.data.toFixed(2)} kwh ${item.data?((item.data/num)*100).toFixed(1):0}%`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          }
        },
        legend: {
          textStyle: {
            color: '#C1D3F4',
            fontSize:14
          },
          itemWidth:12,
          itemHeight:4,
          padding: [12, 0, 0, 0]
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          axisLabel: {
            color: '#C1D3F4'
          },
          axisLine:{
            lineStyle:{
              color:'#5788EC'
            }
          },
          data: datas
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          max:function (value) {
            return parseInt((value.max+3000)/1000)*1000
          },
          // interval:15,
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#5788EC'
            }
          },
          axisLabel: {
            color: '#C1D3F4'
          }
        },
        series: [
          {
            name: '尖时段',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: datas3
          },
          {
            name: '峰时段',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: datas2
          },
          {
            name: '平时段',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: datas1
          },
          {
            name: '谷时段',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: datas4
          }
        ]
      }
      myEchartst.setOption(option)
    }
  },
  beforeDestroy () {
    const $this = this
    clearInterval($this.$_timergetdata)
    $this.$_timergetdata = null
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 1080px;
  overflow: auto;
  background: #001346 url("../../assets/secondary/bg-4.png") no-repeat center bottom;
}
.head-wh{
  height: 147px;
  background: url("../../assets/secondary/title.png") no-repeat center top;
}
.title-center{
  font-size: 36px;
  font-family:"fzskjt";
  color: #D2DFFF;
  font-style: italic;
  padding-top: 15px;
  text-shadow: 3px 2px 7px rgba(0,0,0,0.65);
  line-height: 200%;
  text-align: center;
}

.secondary-content{
  width: 100%;
  height: calc(100% - 90px);
  margin-top: -57px;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pdwk-r{
  width: 1033px;
  height: 990px;
  margin-top: -18px;
  background: url("../../assets/secondary/border-7.png") no-repeat center top;
}

.pdwk-l-t{
  width: 849px;
  height: 274px;
  margin-left: 19px;
  background: url("../../assets/secondary/border-3.png") no-repeat center/100%;
}

.pdwk-l-b{
  width: 887px;
  height: 727px;
  margin-top: -12px;
  padding-top: 20px;
  box-sizing: border-box;
  background: url("../../assets/secondary/border-4.png") no-repeat center bottom;
}

.clinch-deal-list{
  padding: 10px 16px 10px 12px;
  color: #fff;
  font-size: 14px;
}

.clinch-deal-list p,.clinch-deal-list li{
  display: flex;
  justify-content: space-between;
}

.clinch-deal-list p{
  border-bottom: 1px solid #1E60B9;
  padding-bottom: 8px;
}

.clinch-deal-list li{
  height: 38px;
  line-height: 38px;
  font-size: 12px;
  background: rgba(47,62,183,0.9);
}

.clinch-deal-list li:nth-child(even){
  background: rgba(20,36,108,0.9);
}

.clinch-deal-list ul{
  height: 180px;
  overflow: hidden;
}

.clinch-deal-list span{
  text-align: left;
  display: inline-block;
  overflow:hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
  flex: 1;
}

.clinch-deal-list em{
  width: 21px;
  height: 21px;
  border-radius: 50%;
  border: 1px solid #04357D;
  background: #0544A3;
  text-align: center;
  font-style: normal;
  line-height: 21px;
  display: inline-block;
  box-shadow: 1px 2px 2px rgba(0,0,0,0.35);
}

.clinch-deal-list span:first-child{
  width: 40px;
  flex: none;
  text-align: center;
}

.clinch-deal-list span:nth-child(1){
  width: 80px;
}

.clinch-deal-list span:nth-child(2){
  width: 80px;
}

.clinch-deal-list span:nth-child(3){
  width: 80px;
}

.summary{
  width: 716px;
  height: 85px;
  background: url("../../assets/secondary/border-5.png") no-repeat center/100%;
  margin: 0 auto;
  color: #fff;
  font-family: fzskjt;
  font-size: 21px;
  line-height: 85px;
  text-align: center;
}

.summary p{
  background: linear-gradient(to bottom, #fff, #fff,#8EFFFF,#fff, #fff);
  -webkit-background-clip:text;
  color:transparent;
}

.summary a{
  font-size: 32px;
}

.workshop{
  width: 803px;
  height: 434px;
  margin-left: 35px;
  margin-top: 42px;
  position: relative;
  background: url("../../assets/secondary/sbcj.png") no-repeat center/100%;
}

.workshop ul{
  height: 100%;
  width: 100%;
}

.workshop li{
  position: relative;
  border-radius: 6px;
  cursor: pointer;
  /*background: rgba(154,125,25,0.75);*/
  display: flex;
  justify-content: center;
  align-items: center;
}

.workshop-one{
  width: 160px;
  height: 149px;
  position: absolute;
  top: 84px;
  left: 310px;
}

.workshop-one li{
  width: 45%;
  height: 25px;
  margin-right: 3px;
  margin-left: 0;
  float: left;
}

.workshop-two{
  width: 202px;
  height: 149px;
  position: absolute;
  top: 255px;
  left: 43px;
  padding-left: 8px;
  box-sizing: border-box;
  transform:skewX(-15deg);
}

.workshop-two li{
  width: 75px;
  height: 20px;
  margin-right: 21px;
  margin-left: 0;
  float: left;
}

.workshop-three{
  width: 198px;
  height: 149px;
  position: absolute;
  top: 252px;
  left: 297px;
}

.workshop-three li{
  width: 45%;
  height: 24px;
  margin-right: 4.5px;
  margin-left: 2px;
  float: left;
  transform:skewX(-1deg);
}

.workshop-four{
  width: 208px;
  height: 180px;
  position: absolute;
  top: 219px;
  left: 571px;
  transform:skewX(15deg);
}

.workshop-four li{
  width: 43%;
  height: 22px;
  float: left;
  transform:skewX(-15deg);
}

.oee-s{
  width: 100%;
  height: 90px;
  margin: 0 auto;
  margin-top: 38px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}

.oee-s>div{
  width: 167px;
  height: 88px;
  box-sizing: border-box;
  margin: 1px 2px;
  padding-top: 42px;
  background: url("../../assets/secondary/border-6.png") no-repeat center/100%;
  text-align: center;
}

.oee-s>div:nth-child(2){
  width: 197px;
  height: 103.8px;
  margin-top: -12px;
}

.oee-s span{
  font-size: 36px;
  color: #FFC926;
  font-weight: bold;
  font-family: Bahnschrift;
  display: inline-block;
  text-shadow: 3px 2px 7px rgba(0,0,0,0.65);
}

.oee-s em{
  font-size: 14px;
  color: #FFC926;
  font-family: Arial;
}

.oee-s>div:nth-child(1) span,.oee-s>div:nth-child(3) span{
  color: #FC7001;
  font-size: 30px;
  padding-top: 3px;
}

.oee-s>div:nth-child(1) em,.oee-s>div:nth-child(3) em{
  color: #FC7001;
}

.oee-s a{
  font-size: 14px;
  margin-top: -8px;
  color: #D2E4FE;
  display: block;
}

.point-st{
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0f0;
  position: relative;
}

.workshop-two .point-st{
  transform:skewX(15deg);
}

.workshop-three .point-st{
  transform:skewX(1deg);
}

.halo{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0f0;
  animation: flicker_halo 1.5s infinite
}

.line{
  width: 5px;
  height: 32px;
  border-left: 1px solid rgb(220, 20, 60);
  position: absolute;
  top: 1px;
  left: 3px;
  transform: translate(-50%,-50%);
  transform: rotate(-195deg);
  transform-origin: left top
}

.hint{
  position: absolute;
  left: -10px;
  top: -70px;
  transform:translateX(-50%);
  padding: 3px 2px;
  border: 1px solid rgb(220, 20, 60);
  background-color: rgba(220, 20, 60, 0.35);
  display: inline-block;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 20;
  color: #fff;
}

.workshop li.orientation-lt .line{
  height: 42px;
  top: 2px;
  transform: rotate(-125deg);
}
.workshop li.orientation-lt .hint{
  left: 50px;
  top: -62px;
}

.error-st .point-st{
  background: #FF0229;
}
.error-st .halo{
  background: #FF0229;
}

.device-info{
  width: 100%;
  height: 590px;
}

.device-info-title{
  width: 365px;
  height: 103px;
  padding-top: 9px;
  background: url("../../assets/secondary/border-8.png") no-repeat center bottom;
  margin: 0 auto;
  font-size: 26px;
  color: #fff;
  font-weight: bold;
  line-height: 92px;
  text-align: center;
  position: relative;
}

.run-st{
  width: 103px;
  height: 8px;
  background: url("../../assets/secondary/bj-5.png") no-repeat 0 0;
  position: absolute;
  left: 50%;
  margin-left: -51px;
  bottom: 6px;
  animation: flicker_run-st 1s infinite
}

.run-st-error{
  background-position: 0 -7px;
}

.device-infos{
  width: 980px;
  height: 453px;
  margin-left: 21px;
  margin-top: 22px;
  border-bottom: 2px solid #D5CFCE;
  position: relative;
}

.device-info-one{
  background: url("../../assets/secondary/device-7.png") no-repeat center bottom;
}

.device-info .point-st{
  position: absolute;
  background: #A8CCFD;
}

.device-info .halo{
  width: 8px;
  height: 8px;
  background: #4DD2FF;
}

.device-info .line{
  border-left: 1px solid #468DF9;
  width: 0px;
  height: 130px;
  left: 3px;
  border-right: 1px solid rgba(0,0,0,0.15);
  transform: rotate(-180deg);
}

.device-info .hint{
  border: 1px solid #3584F9;
  font-size: 14px;
  left: 0px;
  background-color: rgba(8, 91, 215, 0.45);
  box-shadow: 2px 4px 6px rgba(0,0,0,0.35);
  top:-170px;
  transition: all 1.5s ease;
}

.device-info-one .hint{
  padding: 4px 8px;
}

.device-info .error-st .halo{
  background: #FF0229;
}

.device-info .error-st .line{
  border-left: 1px solid #FF0229;
}

.device-info .error-st .hint{
  background-color: rgba(220, 20, 60, 0.45);
  border: 1px solid #FF0229;
}

.device-info-temperature{
  height: 240px;
}

.device-info-st{
  width: 100%;
  height: 87px;
  display: flex;
  padding: 0 12px 0 21px;
  box-sizing: border-box;
  justify-content: space-between;
  color: #fff;
}

.device-info-st>div{
  border: 1px solid #4B74ED;
  background: #0D2A81;
}

.device-info-st>div:nth-child(1){
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.breathing{
  color: #FF3314;
  animation: flicker_breathing 1s infinite
}

.device-info-oee{
  height: 42px;
  color: #fff;
  padding: 0 12px 0 21px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

.device-info-oee span{
  width: 36px;
  background: #2848C1;
  line-height: 160%;
  height: 100%;
  text-align: center;
}

.device-info-oee em{
  display: block;
  height: 15px;
  line-height: 15px;
  background: #27D40A;
  color: #164A6F;
  padding: 0;
  border: none;
  margin: 0;
}

.device-info-oee em.error{
  background: #EC1C00;
}

.skill-line{
  display: inline-block;
  width: 340px;
  height: 21px;
  background:#0531B4;
  border-radius: 5px;
}

.skill-line i{
  height: 100%;
  display: inline-block;
  text-align: right;
  line-height: 21px;
  font-style: normal;
  background: linear-gradient(to right,#154EF7,#288BE8);
  padding-right: 3px;
  box-sizing: border-box;
  border-radius: 5px;
  position: relative;
}

.skill-line i:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  border-radius: 10px;
  opacity: 0;
  animation: active3_4 3.4s cubic-bezier(.43,1,.52,1) infinite;
  content: " "
}

@keyframes flicker_halo {
  0% {
    transform: scale(1);
    opacity: .9
  }

  to {
    transform: scale(5);
    opacity: .0
  }
}

@keyframes flicker_run-st {
  0% {
    transform: scale(0.7);
    opacity: 1
  }

  to {
    transform: scale(1.1);
    opacity: .8
  }
}

@keyframes flicker_breathing {
  0% {
    opacity: 1
  }
  70%{
    opacity: 0.6
  }
  to {
    opacity: .9
  }
}

@keyframes active3_4 {
  0% {
    width: 0;
    opacity: .1
  }

  20% {
    width: 0;
    opacity: .5
  }

  to {
    width: 100%;
    opacity: 0
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Ld-screen/Pk-workshop.vue